import type RecursiveReadOnly from 'owa-service/lib/RecursiveReadOnly';
import type WorkingHoursType from 'owa-service/lib/contract/WorkingHoursType';
import getUserOptions from './getUserOptions';

export default (): RecursiveReadOnly<WorkingHoursType | undefined> =>
    getUserOptions()?.WorkingHours;
